:host{display:flex;width:100%;height:100%}::ng-deep particle-platform-tool-container{display:flex;flex-grow:1}
/*# sourceMappingURL=admin-panel-user-detail-link.component-WZK6YATF.css.map */
